
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/error/500",
      function () {
        return require("private-next-pages/error/500/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/error/500"])
      });
    }
  